<template>
  <el-dialog
    :close-on-click-modal="false"
    title="报名表单"
    custom-class="project-dialog"
    :visible.sync="ProjectListVisible"
    :lock-scroll="false"
    width="60%"
  >
    <div>
      <div>
        <div class="eig-filter clearfix">
          <div class="float-left float-title">
            <span>基础信息：</span>
          </div>
        </div>
        <div>
          <el-checkbox-group
            class="base-info-checkbox-group"
            v-model="tempFormCheckList"
          >
            <el-checkbox disabled label="name">姓名</el-checkbox>
            <el-checkbox label="gender">性别</el-checkbox>
            <el-checkbox disabled label="phone">手机号码</el-checkbox>
            <el-checkbox label="region">所在地区</el-checkbox>
            <el-checkbox label="address">详细地址</el-checkbox>
            <el-checkbox label="birthDate">出生日期</el-checkbox>
            <el-checkbox disabled label="identity">证件类型</el-checkbox>
            <el-checkbox disabled label="identityNum">证件号码</el-checkbox>
            <el-checkbox label="size">服装尺码</el-checkbox>
            <el-checkbox label="blood">血型</el-checkbox>
            <el-checkbox label="emerg">紧急联系人</el-checkbox>
            <el-checkbox label="emergNum">紧急联系人手机号码</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="eig-filter clearfix">
        <div class="float-left float-title">
          <span>额外信息：</span>
        </div>
        <div class="eig-rght pa-xs">
          <el-button size="small" type="primary" @click="addclassDialog"
            >添加信息</el-button
          >
        </div>
      </div>
      <el-dialog
        append-to-body
        :close-on-click-modal="false"
        title="新增信息"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        :lock-scroll="false"
        width="40%"
      >
        <el-form
          :rules="projectRules"
          ref="projectForm"
          :model="formProject"
          label-width="100px"
        >
          <el-form-item prop="name" label="信息名称：">
            <el-input
              v-model="formProject.name"
              placeholder="请输入信息名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="prompt" label="提示语：">
            <el-input
              v-model="formProject.prompt"
              placeholder="请输入提示语"
            ></el-input>
          </el-form-item>
          <el-form-item prop="groupList" label="指定组别：">
            <el-select
              v-model="formProject.groupList"
              multiple
              style="width: 100%"
              placeholder="请选择组别"
            >
              <el-option
                v-for="item in options"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelInfo" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="submitForm('projectForm')"
            size="small"
            >确 认</el-button
          >
        </div>
      </el-dialog>
      <el-table ref="filterTable" :data="tableData" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="200"
        ></el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="groupList" label="指定组别">
          <template slot-scope="scope">
            {{ scope.row.groupList | filterGroup }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="上移" placement="top">
              <el-button
                size="small"
                icon="el-icon-top"
                circle
                @click="moveInfo(scope.row, scope.$index, 'up')"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="下移" placement="top">
              <el-button
                circle
                icon="el-icon-bottom"
                size="small"
                @click="moveInfo(scope.row, scope.$index, 'down')"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="编辑" placement="top">
              <el-button
                circle
                icon="el-icon-edit"
                size="small"
                @click="editInfo(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top">
              <el-button
                circle
                size="small"
                icon="el-icon-delete"
                @click="deleteInfo(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="ProjectListVisible = false" size="small"
        >取 消</el-button
      >
      <el-button type="primary" @click="saveProject" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import InputNumberRange from "@/components/inputNumberRange.vue";
export default {
  components: {
    InputNumberRange,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    registTime: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    formCheckList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    ProjectListVisible(value) {
      this.$emit("update:visible", value);
    },
    visible: {
      handler(value) {
        this.ProjectListVisible = value;
      },
      immediate: true,
    },
    value: {
      handler(value) {
        this.tableData = JSON.parse(JSON.stringify(value));
      },
      immediate: true,
    },
    formCheckList: {
      handler(value) {
        this.tempFormCheckList = value;
      },
      immediate: true,
    },
  },
  filters: {
    filterGroup(groupList) {
      return groupList.join(",");
    },
  },
  data() {
    return {
      dialogVisible: false,
      ProjectListVisible: this.visible,
      // 绑定表单数据
      formProject: {
        id: "",
        name: "",
        field: "",
        groupList: [],
      },
      tableData: [],
      tempFormCheckList: this.formCheckList,
      // 分页
      page: {
        page_size: 5,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      projectRules: {
        name: [{ required: true, message: "请输入信息名称" }],
        field: [{ required: true, message: "请输入字段名称" }],
      },
      // 控制弹窗
      dialogFormVisible: false,
      isEdit: false,
    };
  },
  mounted() {},
  methods: {
    // 移动
    moveInfo(row, index, direction) {
      let tableData = this.tableData;
      if (direction == "up") {
        if (index == 0) {
          return this.$message.info("无法再上移了！");
        }
        const element = tableData[index];
        tableData.splice(index, 1);
        tableData.splice(index - 1, 0, element);
      } else if (direction == "down") {
        if (index == this.tableData.length - 1) {
          return this.$message.info("无法再下移了！");
        }
        const element = tableData[index];
        tableData.splice(index, 1);
        tableData.splice(index + 1, 0, element);
      }
    },
    saveProject() {
      this.$emit("input", this.tableData);
      this.$emit("changeFormCheckList", this.tempFormCheckList);
      this.ProjectListVisible = false;
    },
    submitForm(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            if (
              this.tableData.find((item) => {
                return (item.name == this.formProject.name) && (item != this.formProject);
              })
            ) {
              return this.$message.error("信息名称已存在");
            }
            this.dialogVisible = false;
          } else {
            if (
              this.tableData.find((item) => {
                return item.name == this.formProject.name;
              })
            ) {
              return this.$message.error("信息名称已存在");
            }
            this.tableData.push({
              name: this.formProject.name,
              field: this.formProject.field
                ? this.formProject.field
                : this.formProject.name,
              prompt: this.formProject.prompt,
              groupList: this.formProject.groupList,
            });
          }

          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteInfo(row) {
      this.tableData.splice(
        this.tableData.findIndex((item) => {
          return item == row;
        }),
        1
      );
    },
    // 编辑
    editInfo(row,index) {
      this.oldFormProject = JSON.stringify(row);
      this.oldIndex = index
      this.formProject = row;
      this.isEdit = true;
      this.dialogVisible = true;
      // this.$forceUpdate()
      
    },
    cancelInfo() {
      if(this.isEdit) {
        this.$set(this.tableData, this.oldIndex, JSON.parse(this.oldFormProject));
        // this.tableData[this.oldIndex] = JSON.parse(this.oldFormProject);
      }
     
      this.dialogVisible = false
    },
    addclassDialog() {
      this.isEdit = false;
      this.formProject = {
        id: "",
        name: "",
        field: "",
        groupList: [],
      };
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped></style>
